import { Banner } from '@walmart-web/livingdesign-components';
import useLocalStorage from '../../hooks/useLocalStorage.ts';
import useFeatureDecision from '../../hooks/useFeatureDecision.ts';
import { BANNER_FEATURE_KEY, INFO_BANNER_KEY } from '../../constants/common';
import { dispatchLocalStorageChangeEvent } from '../../utils/common';

type Props = {
  enable: boolean;
};

function InfoBanner({ enable }: Props) {
  const showBanner = !!useLocalStorage(INFO_BANNER_KEY);
  const [bannerDecision] = useFeatureDecision(BANNER_FEATURE_KEY);

  const onBannerClose = () => {
    localStorage.removeItem(INFO_BANNER_KEY);
    dispatchLocalStorageChangeEvent();
  };

  const bannerText = bannerDecision.variables['banner_text'] as string;
  const enableBanner =
    enable && showBanner && bannerDecision.enabled && !!bannerText;

  if (!enableBanner) {
    return null;
  }

  return (
    <Banner variant="warning" onClose={onBannerClose}>
      {bannerText}
    </Banner>
  );
}

export default InfoBanner;
